// extracted by mini-css-extract-plugin
export default {"character-counter":"character-counter--SB0ysLSjv4","characterCounter":"character-counter--SB0ysLSjv4","exceeded":"exceeded--kCljAKljk-"};